import { Timeline, Avatar, Stack, useBreakpointValue } from "@chakra-ui/react"
import { Provider } from "./components/ui/provider"
import './myCss.css'
import './dsCSS.css'
import { Link, useNavigate } from 'react-router-dom'




const History = () => {
  const timelineSize = useBreakpointValue({
    base: 'xl',
    sm: 'sm'
  })
  const navigate = useNavigate()
  return (
    <body>
      <div className= 'description-ds'>
        <h1 className='description-timeline'>Storyline</h1>
        </div>
      <div className='timeline'>
        <Provider>
        <Stack gap="7">
          <Timeline.Root size={timelineSize} variant="outline">

          <Timeline.Item className= 'spacing-timeline-beginning'>
              <Timeline.Content flex="1"/>
              
                <Timeline.Separator />
                <Timeline.Title id= 'pre-tech'>Pre 2020 - odd jobs, chef, family-owned business</Timeline.Title>
                <Timeline.Connector>
             </Timeline.Connector>

              <Timeline.Content flex="1">


              </Timeline.Content>
            </Timeline.Item>


            <Timeline.Item className= 'spacing-timeline'>
              <Timeline.Content flex="1"  alignItems='flex-end'/>
              <Timeline.Connector>
                <Timeline.Separator />
                <Avatar.Root >
                  <Avatar.Image className="job-avatar" src= 'https://img.icons8.com/dotty/80/FFFFFF/graduation-cap.png'
 />
                  <Avatar.Fallback name="graduated" />
                </Avatar.Root>
                 {/* <Timeline.Indicator />  */}
              </Timeline.Connector>

              <Timeline.Content flex="1">

                <Timeline.Title className="history-left">Aug 2020 - graduated Flatiron School for Data Science</Timeline.Title>
                <h6 className='test-right'>spent 6 months creating projects and learning foundations of ML, data visualization, Python frameworks</h6>

              </Timeline.Content>
            </Timeline.Item>

            <Timeline.Item   className= 'spacing-timeline'>
              <Timeline.Content flex="1" alignItems="flex-end">
                <Timeline.Title className="history">Jan 2022 - Nov 2023 | started work at Publicis Media</Timeline.Title>
                <h6 className='test'>worked at agency handling advertising data and inter-team communication</h6>
              </Timeline.Content>
              <Timeline.Connector>
                <Timeline.Separator />
                <Avatar.Root >
                  <Avatar.Image className='job-avatar' src="https://img.icons8.com/ios/50/FFFFFF/find-matching-job.png" />
                  <Avatar.Fallback name="job" />
                </Avatar.Root>
                {/* <Timeline.Indicator /> */}
              </Timeline.Connector>
              <Timeline.Content flex="1" />
            </Timeline.Item>

            <Timeline.Item className= 'spacing-timeline'>
              <Timeline.Content flex="1"/>
              <Timeline.Connector>
                <Timeline.Separator />
                <Avatar.Root >
                  <Avatar.Image className='job-avatar' src="https://img.icons8.com/sf-black-filled/64/FFFFFF/reading.png" />
                  <Avatar.Fallback name="study" />
                </Avatar.Root>
                {/* <Timeline.Indicator /> */}
              </Timeline.Connector>
              <Timeline.Content flex="1">
                <Timeline.Title className="history-left">Dec 2023 - SWE study</Timeline.Title>
                <h6 className='test-right'>learned JS, React, Flask, and PSQL</h6>
              </Timeline.Content>
            </Timeline.Item>

            <Timeline.Item  className= 'spacing-timeline'>
              <Timeline.Content flex="1" alignItems="flex-end">
                <Timeline.Title className="history">Feb 2024 - Founded JN Web Solutions working on AirBnb booking app</Timeline.Title>
                <h6 className='test'>built booking app and worked on many side projects such as News Aggregator beta version</h6>
              </Timeline.Content>
              <Timeline.Connector>
                <Timeline.Separator />
                <Avatar.Root >
                  <Avatar.Image className = 'job-avatar' src="https://img.icons8.com/ios/50/FFFFFF/5-star-hotel--v2.png" />
                  <Avatar.Fallback name="airbnb" />
                </Avatar.Root>
                {/* <Timeline.Indicator /> */}
              </Timeline.Connector>
              <Timeline.Content flex="1" />
            </Timeline.Item>

            <Timeline.Item  className= 'spacing-timeline'>
              <Timeline.Content flex="1" />
              <Timeline.Connector>
                <Timeline.Separator />
                <Avatar.Root >
                  <Avatar.Image className="job-avatar" src="https://img.icons8.com/glyph-neue/64/FFFFFF/university.png" />
                  <Avatar.Fallback name="university" />
                </Avatar.Root>
                {/* <Timeline.Indicator /> */}
              </Timeline.Connector>
              <Timeline.Content flex="1">
                <Timeline.Title className="history-left">Apr 2025 - started CS major at SNHU</Timeline.Title>
                <h6 className='test-right'>decided to pursue CS degree and gain foundational understanding, build an engineering mindset, and open doors (3.8 GPA)</h6>
              </Timeline.Content>
            </Timeline.Item>

            <Timeline.Item  className= 'spacing-timeline'>
              <Timeline.Content flex="1" alignItems="flex-end">
                <Timeline.Title className="history">Mar 2026 - vibe coded Study Buddy 1.0</Timeline.Title>
                <h6 className='test'>vibe coded a proof of concept SaaS study aid utilizing LLM's capabilities. Building user base.</h6>
              </Timeline.Content>
              <Timeline.Connector>
                <Timeline.Separator />
                <Avatar.Root >
                  <Avatar.Image className="job-avatar" src="https://img.icons8.com/glyph-neue/64/FFFFFF/university.png" />
                  <Avatar.Fallback name="university" />
                </Avatar.Root>
                {/* <Timeline.Indicator /> */}
              </Timeline.Connector>
              <Timeline.Content flex="1" />
            </Timeline.Item>

            <Timeline.Item  className= 'spacing-timeline'>
              <Timeline.Content flex="1" />
              <Timeline.Connector>
                <Timeline.Separator />
                <Avatar.Root >
                  <Avatar.Image className="job-avatar" src="https://img.icons8.com/ios/50/FFFFFF/job.png" />
                  <Avatar.Fallback name="scrabble" />
                </Avatar.Root>
                {/* <Timeline.Indicator /> */}
              </Timeline.Connector>
              <Timeline.Content flex="1">
                <Timeline.Title className="history-left">Aug 2026 - continuing CS study and vibe coded Scrabble</Timeline.Title>
                <h6 className='test-right'>continued CS coursework while building a Scrabble project</h6>
              </Timeline.Content>
            </Timeline.Item>

            <Timeline.Item  className= 'spacing-timeline'>
              <Timeline.Content flex="1" alignItems="flex-end">
                <Timeline.Title className="history">Oct 2026 - dedicating time to personal development</Timeline.Title>
                <h6 className='test'>current leg to push coding limits, build organization, and a user base</h6>
              </Timeline.Content>
              <Timeline.Connector>
                <Timeline.Separator />
                <Avatar.Root >
                  <Avatar.Image className="job-avatar" src="https://img.icons8.com/ios/50/FFFFFF/job.png" />
                  <Avatar.Fallback name="projects" />
                </Avatar.Root>
                {/* <Timeline.Indicator /> */}
              </Timeline.Connector>
              <Timeline.Content flex="1" />
            </Timeline.Item>
          </Timeline.Root>
          </Stack>
        </Provider>
        <div id= 'home-link' className='timeline-home-link'>

<span>
        <a className='description-link-home' onClick={()=>navigate('/home')}>Home</a>
      </span>
      </div>
      </div>
   
    </body>
  )
}
export default History
